import { NumericOptionDropdown } from 'components/dropdown/NumericOptionDropdown';
import { Setting } from 'components/node_settings/V4Settings/Setting';
import { ToggleSetting } from 'components/node_settings/V4Settings/ToggleSetting';
import {
    DEFAULT_LFC_ENABLED,
    V4SensorSettings,
} from 'custom_hooks/data_hooks/v4_sensor_settings/shared';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { OptionChild } from 'utils/node';

// The API accepts only one value per LFC field today: 2000 Hz and exactly 2000
// samples. The wider subset is pending hardware field testing, so keep these in
// sync with the backend YAxisLowFrequencyCollectionSettingsValidator.
const LFC_SAMPLING_FREQUENCY_OPTIONS: OptionChild<number>[] = [
    { Value: 2000, Text: '2000 Hz' },
];
const LFC_NUMBER_OF_SAMPLES_OPTIONS: OptionChild<number>[] = [
    { Value: 2000, Text: '2000 Samples' },
];

export function LowFrequencyCollectionSetting() {
    const { control, setValue } = useFormContext<V4SensorSettings>();
    const lowFrequencyCollection = useWatch({ control, name: 'lowFrequencyCollection' });

    return (
        <>
            <ToggleSetting
                name="Low-Frequency Collection (Y Axis)"
                ariaLabel="Low-Frequency Collection (Y Axis)"
                helperText="Enables a separate, lower-frequency collection. Useful for detecting slow-speed faults without impacting the primary collection. Must be equal to or less than primary collection."
                checked={lowFrequencyCollection.enabled}
                onChange={(checked) =>
                    setValue(
                        'lowFrequencyCollection',
                        checked ? DEFAULT_LFC_ENABLED : { enabled: false },
                        { shouldDirty: true, shouldValidate: true },
                    )
                }
            />

            {lowFrequencyCollection.enabled && (
                <>
                    <Setting name="Sampling Frequency" indented>
                        <Controller
                            control={control}
                            name="lowFrequencyCollection.samplingFrequencyHz"
                            render={({ field }) => (
                                <NumericOptionDropdown
                                    value={field.value}
                                    options={LFC_SAMPLING_FREQUENCY_OPTIONS}
                                    onChange={field.onChange}
                                />
                            )}
                        />
                    </Setting>
                    <Setting name="Number of Samples" indented>
                        <Controller
                            control={control}
                            name="lowFrequencyCollection.numberOfSamples"
                            render={({ field }) => (
                                <NumericOptionDropdown
                                    value={field.value}
                                    options={LFC_NUMBER_OF_SAMPLES_OPTIONS}
                                    onChange={field.onChange}
                                    width="14rem"
                                />
                            )}
                        />
                    </Setting>
                </>
            )}
        </>
    );
}
